module.exports = __webpack_public_path__ + "static/media/brightfoam.232a8ab8.jpg";